<div *ngIf="!isFilterActive" class="placeholder">
  <img class="img-stadium" src="assets/icons/fan.at/stadium.svg" alt="Stadium Icon">
  <h3>
    Keine Spiele verfügbar
  </h3>
  <p>
    Am ausgewählten Tag stehen keine Spiele am Spielplan. Wähle einen anderen Tag aus!
  </p>
  <button class="btn-deactivate-filter mr-1 mat-stroked-button" routerLink="/favoriten">Favoriten hinzufügen</button>
</div>
<div *ngIf="isFilterActive" class="placeholder">
  <img class="img-stadium" src="assets/icons/fan.at/stadium.svg" alt="Stadium Icon">
  <h3>
    Keine Spiele verfügbar
  </h3>
  <p>
    Unter diesem Filter stehen am ausgewählten Tag keine Spiele am Spielplan. Deaktiviere
    den Filter wieder oder wähle einen anderen Tag aus!
  </p>
  <button class="btn-deactivate-filter mr-1 mat-stroked-button"
          (click)="deactivateFilterClicked()">Filter deaktivieren</button>
</div>
